import ThirtyMinuteRoutine from "./ThirtyMinuteRoutine";
import OneHourRoutine from "./OneHourRoutine";
import TwoHourRoutine from "./TwoHourRoutine";
import ThreeHourRoutine from "./Three_Hour_Routine";

export const practiceRoutineCards = [
  {
    key: 1,
    title: "30 Minute Daily Practice Routine",
    text: "Quality over quantity! You can accomplish a lot in 30 minutes if you are organized and consistent.",
    routineCard: ThirtyMinuteRoutine,
  },
  {
    key: 2,
    title: "1 Hour Daily Practice Routine",
    text: "1 hour is a decent amount of time to help you stay focused and in good playing shape.",
    routineCard: OneHourRoutine,
  },
  {
    key: 3,
    title: "2 Hour Daily Practice Routine",
    text: "2 hours is a great amount of time to ensure that you will see results quickly.",
    routineCard: TwoHourRoutine,
  },
  {
    key: 4,
    title: "3 Hour Daily Practice Routine",
    text: "3 hours is a great amount of time if you are considering pursuing music as a career.",
    routineCard: ThreeHourRoutine,
  },
];
